var render, staticRenderFns
import script from "./SchoolCard2.vue?vue&type=script&lang=js&"
export * from "./SchoolCard2.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCard2.vue?vue&type=style&index=0&id=683e2f1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports